import { render, staticRenderFns } from "./deBontje.vue?vue&type=template&id=ccaf9c3a&scoped=true&"
import script from "./deBontje.vue?vue&type=script&lang=js&"
export * from "./deBontje.vue?vue&type=script&lang=js&"
import style0 from "./deBontje.vue?vue&type=style&index=0&id=ccaf9c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf9c3a",
  null
  
)

export default component.exports